


















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import ProfiePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import Datepicker from 'vuejs-datepicker';
import { vxm } from './../../store.vuex';
import { UserProfile } from '../../models/userdata/profile'; 
import { ProtectedInfo } from '../../models/protectedinformation/protectedinfo'
import GenericCustomFields from '@/components/CustomFields/GenericCustomFields.vue';
import moment from 'moment';
import { CustomFields } from '@/models/userdata/customfields';
import { CHECK_BOX ,SHORT_TEXT} from '../../models/jobs/CustomFieldType';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
@Component({
  name: 'ProtectedInformation',
  components: {
    placeholder: ProfiePlaceholder,
    Datepicker,
    GenericCustomFields,
  },
})
export default class ProtectedInformation extends Vue {
  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop() isRequiredStep;
  @Prop() minimumEntries;
  @Prop() isLastStep;
  public protectedList: any[] = [];
  private isViewMode: boolean = true;
  public dateOfBirthText: any = null;
  public dateOfBirthDTTM: string = '';
  $moment: any;
  $wlToastr: any;
  private error: any = {};
  private errorString: string = '';
  private userProfile: UserProfile = new UserProfile();
  private protectedInfo : ProtectedInfo = new ProtectedInfo(); 
  private birthDate: Date = new Date();
  private address: string = '';
  private map: string = '';
  private additionalSupportRequired: string = '0';
  private userProfileBeforeEdit: UserProfile = new UserProfile();
  private protectedInforBeforeEdit;
  private customFieldsModel = {};
  CHECK_BOX = CHECK_BOX;

  addProtectedInformation() {
    this.isViewMode = false;
  }
  editProtectedInformation() {
    this.isViewMode = false;
    this.dateOfBirthText = this.dateOfBirthDTTM
      ? new Date(this.dateOfBirthDTTM)
      : '';
  }

  nextButtonEnabled() {
    setTimeout(() => {
      if (
        this.canShowDob &&
        (this.dateOfBirthText != null || this.dateOfBirthText != '')
      ) {
        this.$emit('disable-next-button', false);
      }
    }, 50);
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'PROTECTED_INFORMATION',
      );
      return section ? section.displayName : 'Protected Information';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'PROTECTED_INFORMATION',
    );
    return section ? section.displayName : 'Protected Information';
  }

  userPermissionConfig(permission) {
    return vxm.configs.getUserPermissionConfig(
      permission,
      'PROTECTED_INFORMATION',
    );
  }

  get canShowDob() {
    return !vxm.configs.canHideThisFieldFromFieldConfig('HIDE_DOB_IN_PROTECTED_INFORMATION', 'PROTECTED_INFORMATION','PROTECTED_INFO_DOB')
  }

  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  get isFieldRequired() {
    if (vxm.configs.IsConfigJSONEnabled) {
        return vxm.configs.requiredFieldConfigValue('PROTECTED_INFORMATION', 'PROTECTED_INFO_DOB');
    }
    return false;
  }

  get isEmptyProtectedInfo() {
    return (
      !this.dateOfBirthDTTM &&
      this.userProfileBeforeEdit &&
      this.userProfileBeforeEdit.customFields &&
      this.userProfileBeforeEdit.customFields.candidateCustomMetaData &&
      this.lodash.isEmpty(
        this.userProfileBeforeEdit.customFields.candidateCustomMetaData
          ? this.userProfileBeforeEdit.customFields.candidateCustomMetaData.filter(
              (item) => item.defaultValue,
            )
          : '',
      )
    );
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  public transformDate(): string {
    if (this.userProfileBeforeEdit.dob) {
      const locale = vxm.users.getUserLang || 'en';
      return moment(this.userProfileBeforeEdit.dob).locale(locale).format(
        this.getCompanyDateFormat.toUpperCase(),
      );
    }
    return '--';
  }

  updateChanges() {
    var flag = this.copyCustomFieldsToRequest();
    if (!flag) {
      return true;
    }
    this.copyCoreFieldsToRequest();
    this.saveUserProfile();
  }

  cancelChanges() {
    this.isViewMode = true;
    this.error = {};
  }
  copyCoreFieldsToRequest() {
    // this.userProfile.dob = this.dateOfBirthText;
    this.protectedInfo.dob = this.dateOfBirthText;
  }

  saveUserProfile() {
    const vm = this;
    // const respPromise: any = vxm.users.saveUserProfile({
    //   userProfile: this.userProfile,
    //   isPartofRegistration: false,
    // });
    const respPromise : any = vxm.protectedinformation.updateProtectedInformation(this.protectedInfo)
    Promise.all([respPromise]).then((values) => {
      console.log("update user profile",values);
      if (values[0].data.meta.success) {
        this.userProfileBeforeEdit = this.lodash.cloneDeep(this.protectedInfo);
        // this.lodash.cloneDeep(this.userProfile);
        vxm.users.Rudderstack.trackEvent("Protected Information Updated", { ProtectedInformationDetails: this.protectedInfo } )
        vm.$wlToastr(
          'success',
          vm.$t('myprofile.update.sucess'),
          vm.$t('UserProfile_MyProfile').toString(),
        );
        this.fetchProfileData();
        this.isViewMode = true;
      } else {
        vm.$wlToastr(
          'error',
          vm.$t('myprofile.update.error'),
          vm.$t('UserProfile_MyProfile').toString(),
        );
      }
    });
  }

  async fetchProfileData() {
    // await vxm.users.updatedUserProfile();
    this.protectedInfo =await vxm.protectedinformation.getProtectedInformation();
    // this.userProfile = vxm.users.myUserProfile; 
    this.userProfileBeforeEdit = this.lodash.cloneDeep(this.protectedInfo);
    // this.dateOfBirthDTTM = vxm.users.myUserProfile.dob;
    this.dateOfBirthDTTM = this.protectedInfo.dob;
    this.loadcustomFieldsModelData();
  }

  loadcustomFieldsModelData() {
    let customFieldsData = {};
    // let metaData = this.userProfile.customFields
    //   ? this.userProfile.customFields.candidateCustomMetaData
    //   : null;
    let metaData = this.protectedInfo.customFields ? this.protectedInfo.customFields.candidateCustomMetaData : null;
    const customMetaDataMap = new Map();
    let metaDataObj = {};
    if (metaData && !this.lodash.isEmpty(metaData)) {
      metaData.forEach((element) => {
        customMetaDataMap.set(element.name, element.displayList);
        metaDataObj[element.name] = element.defaultValue
          ? element.defaultValue
          : '';
      });
    }
    // if (this.userProfile && this.userProfile.customFields) 
    if(this.protectedInfo && this.protectedInfo.customFields){
      for (const dataKey in metaDataObj) {
        if (customMetaDataMap.has(dataKey)) {
          const metaDataValues = customMetaDataMap.get(dataKey);
          const dataValue = metaDataObj[dataKey];
          if (
            (!this.lodash.isEmpty(metaDataValues) &&
              metaDataValues.includes(dataValue)) ||
            dataValue === ''
          ) {
            customFieldsData[dataKey] = dataValue;
          } 
          else {
            customFieldsData[dataKey] = 'Let me type';
            customFieldsData[dataKey + 'letMeType'] = dataValue;
          }
        }
      }
      this.customFieldsModel = this.lodash.cloneDeep(customFieldsData);
    }
    this.additionalSupportRequired = this.userProfile.additionalSupportRequired;
  }

  copyCustomFieldsToRequest() {
    const error = {};
    // this.userProfile.customFields &&
    //   this.userProfile.customFields.candidateCustomMetaData &&
    //   this.userProfile.customFields.candidateCustomMetaData.
    console.log("protected in copyCustomFieldsToRequest ",this.protectedInfo);
    this.protectedInfo.customFields &&
      this.protectedInfo.customFields.candidateCustomMetaData &&
      this.protectedInfo.customFields.candidateCustomMetaData.forEach(
        (metaData) => {
          if(metaData.required && !this.customFieldsModel[metaData.name]) {
            error[metaData.name] = this.$t('this.field.required');
          }
          if (
            metaData.required &&
            this.customFieldsModel[metaData.name] == 0 &&
            metaData.type === CHECK_BOX
          ) {
            error[metaData.name] = this.$t('this.field.required');
          }
          if(metaData.type === SHORT_TEXT && this.customFieldsModel[metaData.name] && metaData.extraConfig){
            const regexPattern = JSON.parse(metaData.extraConfig); 
            if(regexPattern.candidateProfile.validations){
              const regex : RegExp = new RegExp(regexPattern.candidateProfile.validations[0].regex,);
              if (regex && !regex.test(this.customFieldsModel[metaData.name])) { 
                error[metaData.name] = 'Please enter a valid pattern';
              }
            }
          }
        },
      );
    this.error = error;
    if (Object.keys(error).length > 0) {
      return false;
    }
    console.log("this.customFields model",this.customFieldsModel);
    if (this.customFieldsModel) {
      for (const customFieldKey in this.customFieldsModel) {
        const customFieldVal = this.customFieldsModel[customFieldKey];
        if (
          customFieldVal &&
          'Let me type'.toLowerCase() === customFieldVal.toLowerCase()
        ) {
          this.customFieldsModel[customFieldKey] = this.lodash.clone(
            this.customFieldsModel[customFieldKey + 'letMeType'],
          );
        }
        delete this.customFieldsModel[customFieldKey + 'letMeType'];
      }
      if(this.protectedInfo.customFields){
        this.protectedInfo.customFields.candidateCustomData = this.customFieldsModel;
      }
    }
    return true;
  }

  updateDesiredLocation() {
    let locationsElement = this.$el.querySelectorAll('multiselect__tags-wrap');
  }

  async updateDateOfBirth() {
    let vm = this;
    let dob =
      (this.dateOfBirthText &&
        this.$moment(
          vxm.utility.convertLocalTimeToUTC(this.dateOfBirthText),
        )._d.getTime()) ||
      null;
    // 
    const respPromise: any = vxm.protectedinformation.updateProtectedInformation(
      dob ? dob.toString() : 'null',
    );
    const resp = await respPromise;
    if (resp.success) {
      vxm.users.Rudderstack.trackEvent("Protected Information Updated", { ProtectedInformationDetails: this.protectedInfo } )
      vm.$wlToastr('success', 'Updated Protected Information', 'Profile');
      this.dateOfBirthDTTM = this.dateOfBirthText;
      this.isViewMode = true;
    } else {
      vm.$wlToastr('error', 'Error in Protected Information', 'Profile');
    }
  }

  get isGuidedSignup() {
    return this.$route.name && this.$route.name === 'GuidedSignup';
  }

  async mounted() {
    if (this.isGuidedSignup) {
      this.isViewMode = false;
      if(!this.userPermissionConfig('add') || !this.userPermissionConfig ('edit'))
      {
        this.isViewMode = true;
      }
    }
    else{
      this.isViewMode = true;
    }
    // this.isViewMode = !this.isGuidedSignup;
    const disableCheck = this.isGuidedSignup && this.isCustomFieldSectionEnabled;
    // const disable = this.minimumEntries >= 0 ? (this.isRequiredStep ? disableCheck : this.isRequiredStep) : disableCheck;

    this.bus.$on('on-next-step', this.onNextStep);
    // this.$emit('disable-next-button', disable);

    await this.fetchProfileData();
    this.dateOfBirthText = this.dateOfBirthDTTM
      ? new Date(this.dateOfBirthDTTM)
      : '';

      if(this.canShowDob && this.isRequiredStep && this.dateOfBirthDTTM!=null ){
      this.$emit('disable-next-button', false);

      }
      else{
      this.$emit('disable-next-button', true);

    }

  }
  handleUpdateButton(val) {

    if (this.isGuidedSignup) {
      this.$emit('disable-next-button', val);
    }
    return val
  }

  async onNextStep() {
    const hasError = this.updateChanges();
    if (hasError) {
      return
    }
    await vxm.users.validateMandatorySteps();
    if (vxm.users.MissedMandatorySteps.length && this.isLastStep) {
      this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
    }else {
      this.$emit('go-to-next');
    }
 }

  get disabledDates() {
    return {
      from: new Date(),
    };
  }

  get isCustomFieldSectionEnabled() {
    let personalInfoCustomFields = this.userProfileBeforeEdit.customFields;
    if (
      personalInfoCustomFields &&
      personalInfoCustomFields.candidateCustomMetaData &&
      Array.isArray(personalInfoCustomFields.candidateCustomMetaData) &&
      personalInfoCustomFields.candidateCustomMetaData.length > 0
    ) {
      return true;
    }
    return false;
  }

  customData(userProfile) {
    //  let customFields: CustomFields = userProfile.customFields;
    let customFields: CustomFields = this.protectedInfo.customFields;
    if (customFields && customFields.candidateCustomMetaData) {
      let customData: any = customFields.candidateCustomMetaData; // an array of meta data
      let customMetaDataValues = {};
      return customData.map((customMetaData) => {
        let val = '';
        if (customMetaDataValues && customMetaDataValues[customMetaData.name]) {
          val = customMetaDataValues[customMetaData.name];
        }
        if (customData.defaultValue) {
          customMetaDataValues[customMetaData.name] = customData.defaultValue;
        }
        return {
          name: customMetaData.name,
          label: customMetaData.label,
          value: customMetaData.defaultValue,
          id: customMetaData.id,
          type: customMetaData.type,
          defaultValue: customMetaData.defaultValue,
          extraconfig : customMetaData.extraconfig,
        };
      });
    } else {
      return null;
    }
  }
}
